export default __webpack_public_path__ + "static/media/5.40c97235.jpg";